import { RootState } from '../../../applicationStore';
import { ResourceSkillsState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getResourceSkillsState = (state: RootState): ResourceSkillsState =>
  state.resourceSkills;

export const getResourceSkillsLoader = createSelector(
  getResourceSkillsState,
  (state): boolean => state.loading,
);

export const getResourceSkillsData = createSelector(
  getResourceSkillsState,
  (state): ResourceSkillsState['data'] | null => state?.data || [],
);
